import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  deleteProductcategory,
  updateProductcategory,
} from "../graphQL/graphMutation";

export const updateProductcategoryService = async (values, id) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateProductcategory, {
      id: id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.response.errors?.[0].message, "updateProductcategoryService-error");
    errormessage=err.response.errors?.[0].message;
    updateStatus = false;
  }

  return {updateStatus,errormessage};
};

export const delteProductcategoryService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteProductcategory, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "delteProductcategoryService-error");
    delteStatus = false;
  }

  return delteStatus;
};
